/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { bulkPartialPatchDependencyRequestSchema } from './bulkPartialPatchDependencyRequestSchema';
import { customFieldPatchSchema } from './customFieldPatchSchema';
import { patchItemRequestSchema } from './patchItemRequestSchema';

export const bulkPartialPatchRequestSchema = z.object({
  get customFields() {
    return z.array(customFieldPatchSchema).nullish();
  },
  get dependency() {
    return z.union([bulkPartialPatchDependencyRequestSchema, z.null()]).optional();
  },
  get fields() {
    return z.union([patchItemRequestSchema, z.null()]).optional();
  },
  itemIds: z.array(z.int()),
});
